/************
 Product Description Show More
 ************/
const productDescriptionShowMoreButton = document.querySelector("#productContentDescriptionTruncatedShowMoreButton");
const productDescriptionShowLessButton = document.querySelector("#productContentDescriptionFullShowLessButton");
const productDescriptionTruncated = document.querySelector("#productContentDescriptionTruncated");
const productDescriptionFull = document.querySelector("#productContentDescriptionFull");

productDescriptionShowMoreButton?.addEventListener("click", function (e) {
    // Show full text
    productDescriptionFull.classList.add("active");

    // Hide truncated text
    productDescriptionTruncated.classList.add("hidden");
});

productDescriptionShowLessButton?.addEventListener("click", function (e) {
    // Hide full text
    productDescriptionFull.classList.remove("active");

    // Show truncated text
    productDescriptionTruncated.classList.remove("hidden");
});

/************
 Product Dropdowns
 ************/

document.querySelectorAll(".productDropdown").forEach(element => {
    // add event listener to button
    element.querySelector(".productDropdownButton").addEventListener("click", function () {
        // toggle dropdown
        element.classList.toggle("open");
    });
});

// dropdown logo popovers
document.querySelectorAll(".productSpecificationsDropdownLogo[data-tooltip]").forEach(element => {
    tippy(element, {
        content: element.dataset.tooltip,
        theme: 'light'
    });
});
